export default __webpack_public_path__ + "static/logo_OpenCatalogi-8b1b0a001c3f37dae4d3f69b5964ec72.png";